import { SizeUnit } from './size-unit.model';

export class Dimensions {
  length: number;
  width: number;
  height: number;

  constructor(public unit: SizeUnit) {

  }
}
